import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserProfileButton from '../../common/UserProfileButton';
import LogoutButton from '../../common/LogoutButton';
import { getTabTitle } from '../utils/taskUtils';
import './TaskHeader.css';

const TaskHeader = ({ activeTab, isManager, scope }) => {
    const navigate = useNavigate();

    return (
        <div className="task-header">
            <img src="/logo.png" alt="Logo" className="app-logo" />
            <div className="header-text">
                <h1>Task Management</h1>
                <p>{getTabTitle(activeTab, isManager, scope)}</p>
            </div>
            <div className="header-actions">
                <UserProfileButton />
                <button 
                    type="button" 
                    onClick={() => navigate('/tasks/routines')} 
                    className="btn-back"
                >
                    Routine Tasks
                </button>
                <button 
                    type="button" 
                    onClick={() => navigate('/purpose-selection')} 
                    className="btn-back"
                >
                    Back
                </button>
                <LogoutButton variant="secondary" />
            </div>
        </div>
    );
};

export default TaskHeader;
